import type { Project } from '@modules/projects/projects.type'
import { useProjectsStore } from '@modules/projects/stores/projects.store'
import { getCurrentProject } from '@modules/projects/stores/projects.thunks'
import { updateWorkspaceContext } from '@modules/user'
import { setLastUsedWorkspaceIdOnCurrentUser } from '@modules/user/utils/setLastUsedWorkspaceIdOnCurrentUser'
import { useWorkspacesStore } from '@modules/workspaces/stores/workspaces.store'
import { updateLastUsedProject } from '@modules/workspaces/stores/workspaces.thunks'
import { clearClientStoresBeforeWorkspaceContextChange } from '@modules/workspaces/utils/clearClientStoresBeforeWorkspaceContextChange'
import type { Workspace } from '@modules/workspaces/workspaces.type'

export async function switchWorkspace(workspace: Workspace): Promise<Project | null> {
  clearClientStoresBeforeWorkspaceContextChange()
  useProjectsStore.getState().setState({ isResolvingWorkspaceProject: true })
  useProjectsStore.getState().setCurrentProject(null)
  useWorkspacesStore.getState().setCurrentWorkspace(workspace)
  setLastUsedWorkspaceIdOnCurrentUser(workspace.workspaceId)

  try {
    await updateWorkspaceContext(workspace.workspaceId)

    await getCurrentProject(workspace.workspaceId)

    const currentProject = useProjectsStore.getState().currentProject
    if (currentProject?.projectId) {
      if (workspace.lastUsedProjectId !== currentProject.projectId) {
        void updateLastUsedProject(workspace.workspaceId, currentProject.projectId)
      }
    } else if (workspace.lastUsedProjectId) {
      void updateLastUsedProject(workspace.workspaceId, workspace.lastUsedProjectId)
    }

    return currentProject
  } finally {
    useProjectsStore.getState().setState({ isResolvingWorkspaceProject: false })
  }
}
